<template>
  <div id="form">
    <h1>Adicionar Conteúdo ao Website</h1>
    <form v-on:submit.prevent="addContent()" required>
      <div class="form-group">
        <label for="page">Página*</label>
        <select class="form-control" id="page" v-model="idPage">
          <option value="">Escolha a que Página quer adicionar</option>
          <option value="1">HomePage</option>
          <option value="2">Serviços</option>
          <option value="3">Sobre Nós</option>
          <option value="4">Carreira</option>
          <option value="5">Contactos</option>
          <option value="6">Footer</option>
          <option value="7">Navbar</option>
          <option value="8">Error page</option>
          <option value="9">Privacy</option>
        </select>
      </div>
      <div class="form-group">
        <label for="title">Título</label>
        <input
          type="title"
          class="form-control"
          id="description"
          placeholder="Título do conteúdo"
          v-model="title"
        />
      </div>
      <div class="form-group">
        <label for="description">Texto*</label>
      </div>
      <vue-editor
        v-model="content"
        :editorOptions="editorSettings"
        :editor-toolbar="customToolbar"
      ></vue-editor>

      <div class="form-group">
        <label for="title">Título (Inglês):</label>
        <input
            type="title"
            class="form-control"
            id="description"
            placeholder="Título do conteúdo"
            v-model="titleEn"
        />
      </div>
      <div class="form-group">
        <label for="description">Texto* (Inglês) :</label>
      </div>
      <vue-editor
          v-model="contentEn"
          :editorOptions="editorSettings"
          :editor-toolbar="customToolbar"
      ></vue-editor>

      <small>*Campos obrigatórios</small> <br />
      <button type="submit" class="btn btn-primary float-right">
        Adicionar
      </button>
    </form>
  </div>
</template>
<script>
import { VueEditor, Quill } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
import ImageCompress from "quill-image-compress";
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/imageCompress", ImageCompress);
export default {
  components: {
    VueEditor,
  },
  data: function() {
    return {
      content: "",
      title: "",
      contentEn: "",
      titleEn: "",
      idPage: "",
      img: "",
      editorSettings: {
        modules: {
          imageResize: true,
        },
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4] }],
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"],
        ["image"],
      ],
    };
  },
  methods: {
    async addContent() {
      if (this.idPage == "" || this.content == "") {
        this.$swal({
          title: "Campos Obrigatórios Vazios",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      } else {
        this.$swal({
          title: "Quer adicionar este conteúdo?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, Adicionar!",
        }).then((result) => {
          if (result.isConfirmed) {
            try {
              this.$store.dispatch("postContent", {
                title: this.title,
                description: this.content,
                titleEn: this.titleEn,
                descriptionEn: this.contentEn,
                img: this.img,
                idPage: this.idPage,
              });
              this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1500,
                icon: "success",
                title: "Conteúdo Criado!",
              });
              this.title = "";
              this.content = "";
              this.titleEn = "";
              this.contentEn = "";
              this.idPage = "";
            } catch (err) {
              this.$swal({
                title: err.data.status,
                icon: "error",
                confirmButtonText: "Ok!",
              });
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped>
label {
  font-size: 18px;
}
#form {
  text-align: left;
  padding: 50px 60px 0px 300px;
}
</style>
